"use client"

import {Input} from "@heroui/input";
import {Button} from "@heroui/button";
import React, {useState} from "react";

export default function App() {
    const [temporaryChannel, setTemporaryChannel] = useState<string>('lilcherrybomb');

    return (
        <div className={"flex flex-col gap-2"}>
            <Input onValueChange={(value) => setTemporaryChannel(value)} value={temporaryChannel} variant="bordered"
                   isRequired size={"lg"} label="Kick channel slug" placeholder="Enter your email"/>
            <Button onPress={()=> window.open(`/channel/${temporaryChannel}`)} color={"primary"}>Check hidden VODs</Button>
        </div>
    )
}